<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-card v-if="inscription">
          reviewed {{ inscription.reviewed }}
          <v-container>
            <v-row justify="center" align="center">
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.name')"
                  v-model="inscription.name"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.surname')"
                  v-model="inscription.surname"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.fullName')"
                  v-model="inscription.fullName"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  :label="$t('inscription.institution')"
                  v-model="inscription.institution"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  :label="$t('inscription.rol')"
                  v-model="inscription.rol"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col v-if="inscription.inscriptionDate" cols="12">
                <v-text-field
                  disabled
                  :value="
                    $t('inscription.inscriptionDate') +
                      ': ' +
                      new Date(inscription.inscriptionDate.seconds * 1000)
                        .getDate()
                        .toString() +
                      '/' +
                      (
                        new Date(
                          inscription.inscriptionDate.seconds * 1000
                        ).getMonth() + 1
                      ).toString() +
                      '/' +
                      new Date(inscription.inscriptionDate.seconds * 1000)
                        .getFullYear()
                        .toString()
                  "
                >
                </v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  disabled
                  :label="$t('inscription.dateOfBirth')"
                  v-model="inscription.dateOfBirth"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.nacionality')"
                  v-model="inscription.nacionality"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.idNumber')"
                  v-model="inscription.idNumber"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="$t('inscription.address')"
                  v-model="inscription.address"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="5" cols="12">
                <v-text-field
                  :label="$t('inscription.city')"
                  v-model="inscription.city"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field
                  :label="$t('inscription.zipCode')"
                  v-model="inscription.zipCode"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="5" cols="12">
                <v-text-field
                  :label="$t('inscription.country')"
                  v-model="inscription.country"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.email')"
                  v-model="inscription.email"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.altEmail')"
                  v-model="inscription.altEmail"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.phone')"
                  v-model="inscription.phone"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="$t('inscription.emergencyContactInfo')"
                  v-model="inscription.emergencyContactInfo"
                  type="string"
                ></v-text-field>
              </v-col>

              <v-col md="6" cols="12">
                <v-checkbox
                  :label="
                    $t('inscription.previousAssistance2') +
                      (inscription.previousAssistance ? $t('yes') : $t('no'))
                  "
                  v-model="inscription.previousAssistance"
                ></v-checkbox>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-if="inscription.previousAssistance"
                  :label="$t('inscription.previousAssistanceYear')"
                  v-model="inscription.previousAssistanceYear"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox
                  :label="
                    $t('inscription.previousScholarship2') +
                      (inscription.previousScholarship ? $t('yes') : $t('no'))
                  "
                  v-model="inscription.previousScholarship"
                ></v-checkbox>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  v-if="inscription.previousScholarship"
                  :label="$t('inscription.previousScholarshipYear')"
                  v-model="inscription.previousScholarshipYear"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-select
                  :items="['Yes, full', 'Yes, parcial', 'No']"
                  v-model="inscription.askedScholarshipThisYear"
                  :label="$t('inscription.askedScholarshipThisYear')"
                ></v-select>
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox
                  :label="
                    $t('inscription.givenScholarshipCurentYear') +
                      (inscription.givenScholarshipThisYear
                        ? $t('yes')
                        : $t('no'))
                  "
                  v-model="inscription.givenScholarshipThisYear"
                ></v-checkbox>
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox
                  :label="
                    $t('inscription.letterMailed') +
                      (inscription.letterMailed ? $t('yes') : $t('no'))
                  "
                  v-model="inscription.letterMailed"
                ></v-checkbox>
              </v-col>
              <v-col md="6" cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="confirmationLetterMailed"
                      :label="$t('inscription.confirmationLetterMailed')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="confirmationLetterMailed"
                    @input="menu = false"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.amountOwed')"
                  v-model="inscription.amountOwed"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.finalAmountPaid')"
                  v-model="inscription.finalAmountPaid"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="paymentDate"
                      :label="$t('inscription.paymentDate')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paymentDate"
                    @input="menu2 = false"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="$t('inscription.hotelInfo')"
                  v-model="inscription.hotelInfo"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="$t('inscription.flightInfo')"
                  v-model="inscription.flightInfo"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :label="$t('inscription.coordinatorsNote')"
                  v-model="inscription.coordinatorsNote"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col md="12" cols="12">
                <v-checkbox
                  :label="
                    $t('inscription.reviewed') +
                      (inscription.reviewed ? $t('yes') : $t('no'))
                  "
                  v-model="inscription.reviewed"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="mb-3" justify="center" align="center">
              <v-btn @click="saveChanges()">
                {{ $t("inscription.saveChanges")
                }}<v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-row>
            <v-row class="mb-3" justify="center" align="center">
              <v-col md="6" cols="12">
                <v-btn
                  block
                  class="ma-1"
                  @click="
                    downloadFile(
                      '2024/' + inscription.id + '_CV.pdf',
                      '2024/' +
                        inscription.name +
                        '_' +
                        inscription.surname +
                        'CV.pdf'
                    )
                  "
                >
                  {{ $t("inscription.downloadResume")
                  }}<v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col md="6" cols="12">
                <v-btn
                  block
                  class="ma-1"
                  @click="
                    downloadFile(
                      '2024/' + inscription.id + '_letter.pdf',
                      '2024/' +
                        inscription.name +
                        '_' +
                        inscription.surname +
                        '_letter.pdf'
                    )
                  "
                >
                  {{ $t("inscription.downloadLetter")
                  }}<v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col md="12" cols="12">
                <v-btn
                  block
                  class="ma-1 red--text"
                  @click="confirmDeleteInscription()"
                >
                  {{ $t("inscription.delete") }}<v-icon>mdi-alert</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-row justify="center" align="center">
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.newFieldName')"
                  v-model="newFieldName"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field
                  :label="$t('inscription.newFieldValue')"
                  v-model="newFieldValue"
                ></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-btn
                  @click="addNewField"
                  :disabled="!newFieldName || !newFieldValue"
                >
                  {{ $t("inscription.addField") }}<v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  updateInscription,
  getInscription,
  deleteInscription,
} from "@/services/inscriptions.js";
import { getDownloadURL } from "@/services/storage-service";
import { saveAs } from "file-saver";

export default {
  async mounted() {
    //console.log("mounted Inscription Detail");
    if (this.$route.params.inscription) {
      //console.log(1);
      this.inscription = this.$route.params.inscription;
      this.confirmationLetterMailed = this.inscription.confirmationLetterMailed;
      this.paymentDate = this.inscription.paymentDate;
    } else {
      //console.log(2);
      this.inscription = await getInscription(
        this.$route.params.simposioId,
        this.$route.params.inscriptionId
      );
      //console.log("this.inscription", this.inscription);
      //console.log(3);
    }
  },
  data() {
    return {
      inscription: {},
      newFieldName: "",
      newFieldValue: "",
      menu: false,
      menu2: false,
      confirmationLetterMailed: "",
      paymentDate: "",
    };
  },
  methods: {
    addNewField() {
      this.inscription[this.newFieldName] = this.newFieldValue;
      this.newFieldName = "";
      this.newFieldValue = "";
    },
    async saveChanges() {
      this.inscription.confirmationLetterMailed = this.confirmationLetterMailed;
      this.inscription.paymentDate = this.paymentDate;
      updateInscription(
        this.$route.params.simposioId,
        this.inscription.id,
        this.inscription
      );
    },
    async confirmDeleteInscription() {
      deleteInscription(this.$route.params.simposioId, this.inscription.id);
      this.$router.push({
        name: "SymposiaDetail",
        params: { symposiaId: this.$route.params.simposioId },
      });
    },
    async downloadFile(path, fileName) {
      try {
        const url = await getDownloadURL(path);
        saveAs(url, fileName);
      } catch (err) {
        const message = this.$t("downloadingFileError");
        this.setSnackbar({ position: "top", message });
      }
    },
    async viewFile() {},
  },
};
</script>

<style lang="scss" scoped></style>
